import { render, staticRenderFns } from "./BookingItems.vue?vue&type=template&id=6444597e&scoped=true&"
import script from "./BookingItems.vue?vue&type=script&lang=ts&"
export * from "./BookingItems.vue?vue&type=script&lang=ts&"
import style0 from "./BookingItems.vue?vue&type=style&index=0&id=6444597e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6444597e",
  null
  
)

export default component.exports